export default __webpack_public_path__ + "static/media/gulet.f8280297.webp";